import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './modalPropsMap';

export interface ModalStackItem<T extends ModalType = ModalType> {
  id: string;
  type: T;
  openedAt: number;
}

const slice = createSlice({
  name: 'modalStack',
  initialState: [] as ModalStackItem[],
  reducers: {
    openModal(state, { payload }: PayloadAction<ModalStackItem>) {
      state.push(payload);
    },
    closeModal(state, { payload: id }: PayloadAction<string>) {
      return state.filter((item) => item.id !== id);
    },
    replaceModal(state, { payload }: PayloadAction<ModalStackItem>) {
      const item = state.find((modal) => modal.id === payload.id);

      if (!item) return;

      item.type = payload.type;
      item.openedAt = payload.openedAt;
    },
    closeAllModals() {
      return [];
    },
  },
});

export const { openModal, closeModal, replaceModal, closeAllModals } = slice.actions;

export const { reducer } = slice;
